<template>
  <div v-on="$listeners"
       :style="containerStyle">
    <IconSecondary display="block"
                   :content="content"
                   :fontSize="fontSize" />
    <div :style="slotContainerStyle">
      <slot />
    </div>
  </div>
</template>

<script>
  import IconSecondary from '@modules/icon/icon-secondary'
  import { FontStyle } from '@js/styles'

  const truncateText = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };

  export default {
    name: 'IconTextSecondary',
    inheritAttrs: false,
    components: {
      IconSecondary,
    },
    props: {
      content: { type: String, required: true },
      truncate: { type: Boolean, required: false, default: false },
    },
    data: function () {
      return {
        containerStyle: {
          alignItems: 'center',
          display: 'flex',
          width: '100%',
        },
        fontSize: FontStyle.size.md,
        slotContainerStyle: {
          fontFamily: FontStyle.family.primary,
          fontSize: FontStyle.size.sm,
          fontWeight: FontStyle.weight.md,
          marginLeft: '4px',
          ...(this.truncate ? truncateText : {}),
        },
      };
    },
    created: function () {
      this.containerStyle = {
        ...this.containerStyle,
        ...this.$attrs,
      };
    },
  };
</script>
